import { Template } from "../../../models/configuration/definitions/template";
import { Type } from "../../../models/configuration/definitions/widget";

export function getWidgetsKeysTemplates(templates: Template[]): { id: string; type: Type }[] {
  const widgets: {
    id: string;
    type: Type;
  }[] = templates.flatMap((t) => getWidgetsKeysTemplate(t).map((w) => w));
  return widgets;
}

export function getWidgetsKeysTemplate(template: Template): { id: string; type: Type }[] {
  const widgets: {
    id: string;
    type: Type;
  }[] = [];

  template.columns?.forEach((c) => {
    c.widgets?.forEach((w) => {
      widgets.push({
        id: w.id,
        type: w.type,
      });
    });
  });
  return widgets;
}
